var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDynamicHpSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6015 13.0535C17.84 13.1802 18.0239 13.3802 18.1534 13.5802C18.4055 13.9935 18.385 14.5002 18.1398 14.9468L17.6628 15.7468C17.4108 16.1735 16.9407 16.4402 16.4569 16.4402C16.2185 16.4402 15.9528 16.3735 15.7347 16.2402C15.5576 16.1268 15.3532 16.0868 15.1352 16.0868C14.4607 16.0868 13.8952 16.6402 13.8748 17.3002C13.8748 18.0668 13.248 18.6668 12.4645 18.6668H11.5379C10.7476 18.6668 10.1208 18.0668 10.1208 17.3002C10.1072 16.6402 9.54169 16.0868 8.86719 16.0868C8.64236 16.0868 8.43797 16.1268 8.26765 16.2402C8.04963 16.3735 7.77711 16.4402 7.54546 16.4402C7.05492 16.4402 6.58482 16.1735 6.33274 15.7468L5.86264 14.9468C5.61056 14.5135 5.59693 13.9935 5.84901 13.5802C5.95802 13.3802 6.16241 13.1802 6.39406 13.0535C6.58482 12.9602 6.70746 12.8068 6.82328 12.6268C7.16393 12.0535 6.95954 11.3002 6.38043 10.9602C5.70594 10.5802 5.48792 9.7335 5.87627 9.0735L6.33274 8.28683C6.7279 7.62683 7.57271 7.3935 8.25402 7.78016C8.84675 8.10016 9.61663 7.88683 9.9641 7.32016C10.0731 7.1335 10.1344 6.9335 10.1208 6.7335C10.1072 6.4735 10.1821 6.22683 10.3116 6.02683C10.5636 5.6135 11.0201 5.34683 11.5175 5.3335H12.4781C12.9823 5.3335 13.4388 5.6135 13.6908 6.02683C13.8135 6.22683 13.8952 6.4735 13.8748 6.7335C13.8612 6.9335 13.9225 7.1335 14.0315 7.32016C14.379 7.88683 15.1488 8.10016 15.7484 7.78016C16.4229 7.3935 17.2745 7.62683 17.6628 8.28683L18.1193 9.0735C18.5145 9.7335 18.2965 10.5802 17.6151 10.9602C17.036 11.3002 16.8316 12.0535 17.1791 12.6268C17.2881 12.8068 17.4108 12.9602 17.6015 13.0535ZM10.0731 12.0068C10.0731 13.0535 10.9384 13.8868 12.008 13.8868C13.0777 13.8868 13.9225 13.0535 13.9225 12.0068C13.9225 10.9602 13.0777 10.1202 12.008 10.1202C10.9384 10.1202 10.0731 10.9602 10.0731 12.0068Z",
    fill: "#367F98"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#F0F3F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicHpSetting);
export default __webpack_public_path__ + "static/media/DynamicHPSetting.a4a8bb9bdab176a1c3f852fceccd7973.svg";
export { ForwardRef as ReactComponent };